import AuditForm from './src'

AuditForm.install = Vue => {
  Vue.component(AuditForm.name, AuditForm)
}

export default AuditForm
